var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
define(["require", "exports", "./base-page"], function (require, exports, base_page_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    class PostsPage extends base_page_1.BasePage {
        onDocumentReady() {
            const _super = Object.create(null, {
                onDocumentReady: { get: () => super.onDocumentReady }
            });
            return __awaiter(this, void 0, void 0, function* () {
                console.log('PostsPage ready!!');
                _super.onDocumentReady.call(this);
                yield this.asyncGetAccount(false, false);
                this.initMethod();
                this.positionElement();
            });
        }
        positionElement() {
            let positionElement = this.getCategoryByLocation();
            if (positionElement != "") {
                let x = $("." + positionElement).offset().left;
                $(".nav-container").scrollLeft(x);
            }
        }
        getCategoryByLocation() {
            let pageLocation = location.pathname;
            let pageArr = pageLocation.split("/");
            if (pageArr[1] == "article" && pageArr[2] == "category" && pageArr[3] != null) {
                return pageArr[3];
            }
            return "";
        }
        initMethod() {
            if (this.system === 'pc') {
                $('body').find('.carousel-indicators .pc-none').remove();
                $('body').find('.carousel-inner .pc-none').remove();
            }
        }
    }
    exports.default = PostsPage;
});
